import React from 'react';
import classNames from 'classnames';
import { FaChartLine } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { TRADE_SUMMARY_CHART } from '../../util/routeConstants';
import styles from './StatsHeader.module.scss';
import Stat from './Stat';

class StatsHeader extends React.Component {
  render () {
    const { className, stats, chartIcon, topBorder } = this.props;
    return (
      <div className={classNames(styles.container, className, {
        [styles.topBorder]: topBorder
      })}>
        {stats.map((stat, i) => stat.value !== undefined && <Stat key={`Stats-${i}`} title={stat.title || stat.name || ''} value={stat.value} />)}
        {chartIcon &&
          <div id={'Stats-chart'} className={classNames(className, styles.stat, styles.chartIcon)}>
            <h1 className={styles.statTitle}>{'Summary Chart'}</h1>
            <div className={styles.statValue}>
              <Link to={TRADE_SUMMARY_CHART.path}>
                <FaChartLine />
              </Link>
            </div>
          </div>}
      </div>

    );
  }
}
StatsHeader.propTypes = {
  /** Class name of the input, for custom designs */
  className: PropTypes.string,
  /** Object of stats */
  stats: PropTypes.array,
  topBorder: PropTypes.bool,
  chartIcon: PropTypes.bool
};

export default StatsHeader;
